import { useEffect } from 'react';
import { useTranslationEditor } from './TranslationEditorContext';

export const editTranslationsShortcutLabel = 'Alt+Shift+T';

type ShortcutKeys = {
    altKey: boolean;
    shiftKey: boolean;
    ctrlKey: boolean;
    metaKey: boolean;
    code: string;
};

export function isEditTranslationsShortcut(event: ShortcutKeys): boolean {
    return (
        event.altKey && event.shiftKey && !event.ctrlKey && !event.metaKey && event.code === 'KeyT'
    );
}

export function useEditTranslationsShortcut(allowed: boolean) {
    const { editTranslationsEnabled, enableEditTranslations, disableEditTranslations } =
        useTranslationEditor();

    // eslint-disable-next-line no-restricted-syntax -- global keyboard shortcuts are a document event subscription, which needs an effect with cleanup
    useEffect(() => {
        if (!allowed) {
            return undefined;
        }

        function handleKeyDown(event: KeyboardEvent) {
            if (isEditTranslationsShortcut(event)) {
                event.preventDefault();
                if (editTranslationsEnabled) {
                    disableEditTranslations();
                } else {
                    enableEditTranslations();
                }
                return;
            }

            if (editTranslationsEnabled && event.key === 'Escape') {
                event.preventDefault();
                event.stopImmediatePropagation();
                disableEditTranslations();
            }
        }

        document.addEventListener('keydown', handleKeyDown, true);
        return () => document.removeEventListener('keydown', handleKeyDown, true);
    }, [allowed, editTranslationsEnabled, enableEditTranslations, disableEditTranslations]);
}
